{
  "uigWishList": {
    "itemPrice": "EK-Preis",
    "errors": {
      "notListed": "Dieser Artikel kann leider nicht bestellt werden und wird daher nicht in den Merkzettel übernommen."
    }
  }
}
